import React, { useState } from "react";
import { Menu, MenuItem, IconButton, Box, Divider, Tooltip } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ByzMuiTypography from "../inputs/ByzMuiTypography";
import { GridToolbarQuickFilter } from "@mui/x-data-grid"; // Gerekli import


import { useTranslate } from "src/locales";
//IDOGAN;436653;21022025
interface MenuItemType {
  label: any;
  iconColor?:
  | "primary"
  | "secondary"
  | "error"
  | "warning"
  | "info"
  | "success";
  onClick: () => void;
  disabled?: boolean;
  divider?: boolean;
  tooltip?: string;
  sx?: any;
}

interface ByzMuiOpenProcessMenuProps {
  menuItems: MenuItemType[];
  triggerElement?: React.ReactNode;
  inSearch?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  sx?: any;
  hideHeaderTitle?: boolean;
  /** onlyDesign=true ise sadece ikon render edilir, hiçbir MUI Menu açılmaz */
  onlyDesign?: boolean;
}

const ByzMuiOpenProcessMenu: React.FC<ByzMuiOpenProcessMenuProps> = ({
  menuItems,
  triggerElement,
  inSearch,
  onOpen,
  onClose,
  sx,
  hideHeaderTitle,
  onlyDesign,
}) => {
  const { t } = useTranslate();
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(menuAnchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    // onlyDesign modunda sadece onOpen tetiklenir, menü hiç açılmaz
    if (onlyDesign) {
      if (onOpen) {
        onOpen();
      }
      return;
    }

    setMenuAnchorEl(event.currentTarget);
    if (onOpen) {
      onOpen(); // Menü açıldığında onOpen fonksiyonunu çağır
    }
  };

  const handleClose = () => {
    setMenuAnchorEl(null);
    if (onClose) {
      onClose();
    }
  };

  const CustomToolbarSearch = () => {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <GridToolbarQuickFilter
          placeholder="Ara"
          sx={{ mb: 2, width: "100%" }}
        />
      </Box>
    );
  };

  return (
    <Box sx={sx}>
      {triggerElement ? (
        <Box onClick={handleClick}>{triggerElement}</Box>
      ) : (
        <IconButton onClick={handleClick}>
          <MoreHorizIcon />
        </IconButton>
      )}

      {/* onlyDesign=true iken, arkaplanda hiç MUI Menu açma */}
      {onlyDesign ? null : (
        <Menu
          open={isOpen}
          anchorEl={menuAnchorEl}
          onClose={handleClose}
          sx={{
            "& .MuiPaper-root": {
              width: inSearch ? "400px" : "250px",
              padding: "8px",
              borderRadius: "8px",
            },
          }}
        >
          {!hideHeaderTitle && (//IDOGAN; "SEÇİNİZ" BASLIGI GEREKTIGINDE GIZLENEBILIR HALE GETIRILDI
            <ByzMuiTypography
              sx={{
                marginLeft: "0px",
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: "bold",
                color: "text.primary",
              }}
            >
              {inSearch === true ? (
                <CustomToolbarSearch />
              ) : (
                t("open-process-menu.select")
              )}
            </ByzMuiTypography>
          )}

          {menuItems.map((item, index) => {
            const menuItem = (
              <MenuItem
                onClick={item.onClick}
                sx={{ display: "flex", alignItems: "center" }}
                disabled={item.disabled}
              >
                {item.iconColor && (
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      bgcolor: `${item.iconColor}.main`,
                      mr: 1,
                    }}
                  />
                )}
                <ByzMuiTypography textAlign="left" sx={{ marginLeft: "0px" }}>
                  {item.label}
                </ByzMuiTypography>
              </MenuItem>
            );

            return (
              <React.Fragment key={index}>
                {item.tooltip ? (
                  <Tooltip title={item.tooltip}>
                    <Box component="span" sx={{ display: "block" }}>
                      {menuItem}
                    </Box>
                  </Tooltip>
                ) : (
                  menuItem
                )}
                {item.label === "Reddet" && <Divider />}
                {item.divider && <Divider sx={{ borderColor: "#E0E0E0" }} />}
              </React.Fragment>
            );
          })}

          <MenuItem onClick={handleClose}>
            <ByzMuiTypography sx={{ marginLeft: "0px", color: "primary.main" }}>
              {t("open-process-menu.close")}
            </ByzMuiTypography>
          </MenuItem>
        </Menu>
      )}
    </Box>
  );
};

export default ByzMuiOpenProcessMenu;
